import { render } from "./ToolsSettingsSection.vue?vue&type=template&id=5529501b"
import script from "./ToolsSettingsSection.vue?vue&type=script&lang=js"
export * from "./ToolsSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__